import React, {useContext, useState} from 'react';
import ItemForm from "./ItemForm";
import {Context} from "../../index";
import {createItem} from "../../http/itemsAPI";
import {observer} from "mobx-react-lite";

const ItemCreation = observer(({show, onHide}) => {
    const {items} = useContext(Context)
    const [item, setItem] = useState({
        title: '',
        description: '',
        price: 0,
        count: 0,
        category: ''
    })
    const [uploadFiles, setUploadFiles] = useState([])

    const create = () => {
        if (uploadFiles.length < 1) {
            alert('Добавьте хотя бы одно фото.')
            return
        }
        createItem(item, uploadFiles)
            .then(() => {
                setUploadFiles([])
                onHide(false)
            })
            .catch(error =>
                alert(error.response?.data?.message || error.message || 'Ошибка создания товара'))
    }

    return (
        <ItemForm
            variant="create"
            show={show}
            onHide={() => { setUploadFiles([]); onHide(false); }}
            sendRequest={create}
            item={item}
            setItem={setItem}
            items={items}
            uploadFiles={uploadFiles}
            setUploadFiles={setUploadFiles}
        />
    );
});

export default ItemCreation;
